module.exports = __webpack_public_path__ + "img/newyear_title1.9f4377a3.png";